export function generateDifferentialJson (data, config, initialJson, attributesGroups) {
	var differentialJson = {}
	_.each(data, function (value, key) {
		if (!config[key]['multiple']) {
			generateSingleAttribute(key, value, config[key]['type'], differentialJson, initialJson, attributesGroups)
		} else {
			generateMultipleAttribute(key, value, config[key]['type'], differentialJson, initialJson, attributesGroups)
		}
	})
	return differentialJson
}

function generateSingleAttribute (attributeName, attributeValue, attributeType, differentialJson, initialJson, attributesGroups) {
	if (attributeType === 'N') {
		var value = ($.isNumeric(parseFloat(formatNumberReverse(String(attributeValue))))) ? parseFloat(formatNumberReverse(String(attributeValue))) : null
		writeSingleSNDBL(attributeName, attributeType, value, initialJson, attributesGroups, differentialJson)
	} else if (attributeType === 'S' || attributeType === 'B' || attributeType === 'D' || attributeType === 'L') {
		writeSingleSNDBL(attributeName, attributeType, attributeValue, initialJson, attributesGroups, differentialJson)
	} else if (attributeType === 'NM') {
		writeSingleNM(attributeName, attributeValue, initialJson, attributesGroups, differentialJson)
	} else if (attributeType === 'SL') {
		writeSingleSL(attributeName, attributeValue, initialJson, attributesGroups, differentialJson)
	}
}

function generateMultipleAttribute (attributeName, attributeValue, attributeType, differentialJson, initialJson, attributesGroups) {
	if (attributeType === 'N') {
		writeMultipleSNDLA(attributeName, attributeValue, initialJson, attributesGroups, differentialJson, true)
	} else if (attributeType === 'S' || attributeType === 'D' || attributeType === 'L' || attributeType === 'A') {
		writeMultipleSNDLA(attributeName, attributeValue, initialJson, attributesGroups, differentialJson, false)
	} else if (attributeType === 'NM') {
		writeMultipleNM(attributeName, attributeValue, initialJson, attributesGroups, differentialJson)
	}
}

function writeSingleSNDBL (attributeName, attributeType, attributeValue, initialJson, attributesGroups, differentialJson) {
	if (attributesGroups.indexOf(attributeName) !== -1) {
		var initialValue = ((attributeType === 'D') && initialJson[attributeName]) ? initialJson[attributeName].slice(0, 10) : initialJson[attributeName]
		var bothEmpty = (_.isNull(initialValue) || _.isUndefined(initialValue)) && (_.isNull(attributeValue) || _.isUndefined(attributeValue))
		var isEqual = _.isEqual(initialValue, attributeValue)

		if (attributeType === 'B') {
			if (attributeValue !== undefined) {
				if (_.isUndefined(initialJson[attributeName]) && attributeValue === true) {
					differentialJson[attributeName] = attributeValue
				}
				if (_.isUndefined(initialJson[attributeName]) && window.batchUpdateManager && (attributeValue === false || attributeValue === true)) {
					differentialJson[attributeName] = attributeValue
				}
				if (!_.isUndefined(initialJson[attributeName]) && attributeValue !== initialJson[attributeName]) {
					differentialJson[attributeName] = attributeValue
				}
			}

			return
		}

		if (!bothEmpty && !isEqual) {
			differentialJson[attributeName] = attributeValue
		}
	}
}

function writeSingleNM (attributeName, attributeValue, initialJson, attributesGroups, differentialJson) {
	if (attributesGroups.indexOf(attributeName) !== -1) {
		if (attributeValue && attributeValue['val']) {
			attributeValue['val'] = !_.isEmpty(formatNumberReverse(String(attributeValue['val']))) ? parseFloat(formatNumberReverse(String(attributeValue['val']))) : null

			if (initialJson[attributeName] && initialJson[attributeName]["val"]) {
				if ((Number(initialJson[attributeName]['val']) !== attributeValue['val']) || (initialJson[attributeName]['mu'] !== attributeValue['mu'])) {
					differentialJson[attributeName] = attributeValue
				}
			} else if (attributeValue['val'] !== 0) {
				differentialJson[attributeName] = attributeValue
			} else if (attributeValue["val"] === 0 && initialJson[attributeName] && (initialJson[attributeName]['mu'] !== attributeValue["mu"])) { // mu
				differentialJson[attributeName] = {
					"val": 0,
					"mu": attributeValue["mu"]
				}
			} else if (attributeValue["val"] === 0 && (!initialJson[attributeName] || (initialJson[attributeName] && initialJson[attributeName]["val"] !== attributeValue["val"]))) {
				differentialJson[attributeName] = {
					"val": 0,
					"mu": attributeValue["mu"]
				}
			}
		} else if (!initialJson[attributeName] && attributeValue && attributeValue['val'] === 0) {
			differentialJson[attributeName] = {
				"val": 0,
				"mu": attributeValue["mu"]
			}
		} else if (initialJson[attributeName] && initialJson[attributeName]["val"] === 0 && attributeValue && attributeValue['val'] === 0) { // mu
			if (initialJson[attributeName]["mu"] !== attributeValue["mu"]) {
				differentialJson[attributeName] = {
					"val": 0,
					"mu": attributeValue["mu"]
				}
			}
		} else if (initialJson[attributeName] && initialJson[attributeName]["val"] && !attributeValue["mu"]) {
			differentialJson[attributeName] = { "val": null, "mu": editableTradeItem.itemConfig[attributeName]["defaultValue"]["mu"] }
		} else if (initialJson[attributeName] && initialJson[attributeName]["val"] && attributeValue["mu"]) {
			differentialJson[attributeName] = { "val": null, "mu": attributeValue["mu"] }
		} else if (initialJson[attributeName] && initialJson[attributeName]["val"] !== 0 && attributeValue && attributeValue["val"] === 0) {
			differentialJson[attributeName] = { "val": 0, "mu": attributeValue["mu"] }
		} else if (initialJson[attributeName] && initialJson[attributeName]["val"] !== null && attributeValue && (isNaN(attributeValue["val"]) || attributeValue["val"] === null)) {
			differentialJson[attributeName] = { "val": null, "mu": attributeValue["mu"] }
		}
	}
}

function writeSingleSL (attributeName, attributeValue, initialJson, attributesGroups, differentialJson) {
	if (attributesGroups.indexOf(attributeName) !== -1) {
		if (!differentialJson[attributeName]) {
			differentialJson[attributeName] = {}
		}

		if (initialJson[attributeName]) {
			_.each(initialJson[attributeName], function (value, language) {
				if (!attributeValue || !attributeValue[language]) {
				}
				// differentialJson[attributeName][language] = null;
				else {
					if (attributeValue[language] !== value) {
						differentialJson[attributeName][language] = attributeValue[language]
					}
					delete attributeValue[language]
				}
			})
		}

		if (!_.isEmpty(attributeValue)) {
			_.each(attributeValue, function (value, language) {
				differentialJson[attributeName][language] = value
			})
		}

		if (_.isEmpty(differentialJson[attributeName])) {
			delete differentialJson[attributeName]
		}
	}
}

function writeMultipleSNDLA (attributeName, attributeValue, initialJson, attributesGroups, differentialJson, number) {
	if (attributesGroups.indexOf(attributeName) !== -1) {
		if (attributeValue && number) {
			_.each(attributeValue, function (value, index) {
				value = ($.isNumeric(parseFloat(formatNumberReverse(String(value))))) ? parseFloat(formatNumberReverse(String(value))) : null
				attributeValue[index] = value
			})
		}

		var bothEmpty = _.isEmpty(initialJson[attributeName]) && _.isEmpty(attributeValue)
		var isEqual = _.isEqual(initialJson[attributeName], attributeValue)
		if (!bothEmpty && !isEqual) {
			differentialJson[attributeName] = attributeValue
		}
	}
}

function writeMultipleNM (attributeName, attributeValue, initialJson, attributesGroups, differentialJson) {
	if (attributesGroups.indexOf(attributeName) !== -1) {
		if (attributeValue) {
			_.each(attributeValue, function (value, index) {
				value['val'] = !_.isEmpty(formatNumberReverse(String(value['val']))) ? parseFloat(formatNumberReverse(String(value['val']))) : null
				attributeValue[index] = value
			})
		}

		var bothEmpty = _.isEmpty(initialJson[attributeName]) && _.isEmpty(attributeValue)
		var isEqual = _.isEqual(initialJson[attributeName], attributeValue)
		if (!bothEmpty && !isEqual) {
			differentialJson[attributeName] = attributeValue
		}
	}
}

export function formatNumberReverse (value, vm) {
	if (value === null || value === undefined) {
		return
	}

	if (!vm) {
		var setting = window.editableTradeItem.getDecimalOrDigitSettings()
	} else {
		setting = vm.$store.getters.getPerson
	}

	var separator = (setting.digitGroupingSeparator === ' ') ? /\s+/g : new RegExp('\\' + setting.digitGroupingSeparator + '+', 'g')

	if (value.indexOf(',') > 0) {
		value = value.replace(',', '.')
	}

	if ((setting.digitGroupingPattern !== '0') && (value !== null)) {
		return value.replace(separator, '');
	}
	return value;
}
